<template>
  <div id="mymoney">
    <div class="box-top">
      <el-row class="title">
        <el-col :span="24">
          <div style="margin-bottom:16px;height: 40px;font-size: 24px;font-family: MicrosoftYaHei;color: #262626;line-height: 40px;" >我的{{$store.state.name}}</div>
        </el-col>
        <el-row style="margin-top:54px;">
        <el-col :span="24" style="display: flex;justify-content: space-between;    padding: 0px 30px;">
          <div class="moneybox">
            <div>
              <img src="/static/img/dqjf.png" />
            </div>
            <div>
              <p class=" gota">{{point.detail.point}}</p>
              <p class="text ">当前{{$store.state.name}}</p>

            </div>
          </div>
          <div class="moneybox">
            <div>
              <img src="/static/img/ljjfxf.png" />
            </div>
             <div>

            <p class="gota">{{point.detail.tatal_point}}</p>
            <p class="text">累计{{$store.state.name}}</p>
             </div>
          </div>
          <div class="moneybox">
            <div>
              <img src="/static/img/jfxh.png" />
            </div>
             <div>

            <p class="gota">{{point.detail.cost_point}}</p>
             <p class="text">消耗{{$store.state.name}}</p>
             </div>
          </div>
        </el-col>
      </el-row>
      </el-row>
    </div>
    <div class="inner">


      <div class="tabs">
        <ul>
          <!-- <li>
            <span>积分变动记录</span>
          </li> -->
          <li>
            <span @click="record(0)" :class="this.pointstatus == 0?'theme-col':''">全部</span>
          </li>
          <li>
            <span @click="record(1)" :class="this.pointstatus == 1?'theme-col':''">收入</span>
          </li>
          <li>
            <span @click="record(2)" :class="this.pointstatus == 2?'theme-col':''">支出</span>
          </li>
          <div style="clear:both"></div>
        </ul>
      </div>
      <div class="points-info">
        <el-table
    :data="point.list"
    stripe
    :header-cell-style="{'background': '#F5F5F5','text-align':'center','font-weight':'500','font-size': '15px',
'font-family':' MicrosoftYaHei',
'color': '#262626'}"
    style="width: 100%">
    <el-table-column
      prop="source"
      align='center'
      label="变动来源"
      width="180">
    </el-table-column>
    <el-table-column
      prop="time"
      label="时间"
      align='center'
      width="180">
      <template  slot-scope="scope">
        {{times(scope.row.time)}}
      </template>
    </el-table-column>
    <el-table-column
      prop="address"
       width="120"
       align='center'
      label="积分">
      <template slot-scope="scope">
         <span class="plus" v-if='scope.row.type==1'>+{{scope.row.point}}</span>
           <span class="minus" v-if='scope.row.type==2'>-{{scope.row.point}}</span>
      </template>
    </el-table-column>
       <el-table-column
      prop="memo"
      show-overflow-tooltip
      label="备注">

    </el-table-column>
  </el-table>

        <!-- <div class="points-row points-th">
          <span>变动来源</span>
          <span>时间</span>
          <span>积分</span>
          <span>备注</span>
        </div>
        <div class="points-row" v-for="item in point.list" :key="item.id">
          <span>{{item.source}}</span>
          <span>{{times(item.time)}}</span>
          <span class="plus" v-if='item.type==1'>+{{item.point}}</span>
           <span class="minus" v-if='item.type==2'>-{{item.point}}</span>
          <span>
            <div style="font-size: 12px;">{{item.memo}}</div>
          </span>
        </div> -->
      </div>
          <div style="margin: 15px 25px 0px 0;text-align: right" class="block" v-if="count>20">
         <el-pagination

            layout="prev,pager, next"
            :total="count" :page-size="20" :current-page.sync="page"
          ></el-pagination>
        <!-- <el-pagination layout="pager" :total="count" :page-size="20" :current-page.sync="page"></el-pagination> -->
      </div>
    </div>
    <!-- 分页 -->

  </div>
</template>
<script>
export default {
  data() {
    return {
      point: '',
      pointstatus: 0,
      page: 1,
      count:'',
    };
  },
  watch:{
    page(oldV, newV) {
      this.getpoint();
    }
  },
  methods: {
    //获取积分
    getpoint: function() {
      this.$api.get(
        "user/point/plist", {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          status: this.pointstatus,
          pageIndex:this.page
        },
        res => {
          if(res.data.code==100){
            this.point = res.data.data
            this.count=res.data.data.totalPage*20
          }
        }
      );
    },
    record:function(num){
      this.pointstatus=num
      this.page=1
      this.getpoint()
    },
    //时间戳
    times:function (timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m
        if(date.getMinutes()<10){
          m='0'+date.getMinutes()+':'
        }else{
          m = date.getMinutes()+':';
        }
        var s
        if(date.getSeconds()<10){
          s='0'+date.getSeconds()
        }else{
          s = date.getSeconds();
        }
        return Y+M+D+h+m+s;
      },
  },
  mounted() {
    this.getpoint()
  }
};

</script>
<style lang="less" scoped>
/deep/ .el-pager li{
      width: 35px !important;
    height: 35px !important;
    background: #FFFFFF !important;
    border-radius: 3px !important;
    border: 1px solid #E7E7E7 !important;
    margin: 0px 2.5px !important;
}
/deep/ .el-pagination .btn-next, /deep/.el-pagination .btn-prev{
width: 35px !important;
    height: 35px !important;
    background: #FFFFFF !important;
    border-radius: 3px !important;
    border: 1px solid #E7E7E7 !important;
    margin: 0px 2.5px !important;
}
/deep/ .el-pager li.active {
  color:#E53940 !important;
  background: rgba(229, 57, 64, 0.1) !important;
  border: 1px solid #E53940 !important;
}
/deep/ .el-table .cell.el-tooltip {
    white-space: none !important;
    min-width: 50px;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: break-spaces;
    &:hover{
        -webkit-line-clamp: revert;
    }
}
#mymoney {
    width: 985px;
  min-height: 605px;
  float: left;
 .plus{
   height: 17px;
font-size: 13px;
font-family: MicrosoftYaHei;
color: #12B1BF;
line-height: 17px;
 }
 .minus{
   height: 17px;
font-size: 13px;
font-family: MicrosoftYaHei;
color: #E23130;
line-height: 17px;
 }
.box-top{
  padding:10px 30px 16px 30px;
   background: #fff;
   box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
}
  .inner {
    margin-top: 15px;
    box-sizing: border-box;
    padding: 20px 30px;
    background: #FFFFFF;
box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
    min-height: 385px;
    .tabs {

    }

    ul {
     border-bottom: solid 1px #f5f5f5;
      // overflow: hidden;
      margin-bottom: 15px;

      li {
        float: left;

        font-size: 14px;
        // border-left: 1px solid #cccccc;
        span{
          display: inline-block;
          height: 20px;
font-size: 15px;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 20px;
width: 110px;
text-align: center;
padding-bottom: 10px;
position: relative;
        }
       .theme-col{
         height: 20px;
    font-size: 15px;
font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
font-weight: bold;
color: #262626 !important;
line-height: 20px;
position: relative;
 &::after{
 content: '';
  left: 0;
  bottom: -1px;
  width: 110px;
  position: absolute;
  height: 2px;
background: #E23130;
}
       }

      }

      li:nth-child(1) {
        border: 0;
        padding-left: 0;

        span {
          // font-weight: 600;
          // font-size: 16px;
        }
      }

      li:nth-child(2) {
        border: 0;
      }
    }

    .points-info {
      border:1px solid #e3e3e3;
      border-bottom: none;

      .points-row {
        padding-left: 30px;
        height: 54px;
        line-height: 54px;
        font-size: 12px;
        color: #565656;
        .plus{
          color:#F83132;
        }
        .minus{
          color: #579F2C;
        }
        span{
          display: block;
          float: left;
          height: 100%;
        }
        &>span:nth-child(1){
          width: 198px;
        }
        &>span:nth-child(2){
          width: 243px;
        }
        &>span:nth-child(3){
          width: 180px;
        }
        &>span:nth-child(4){
          width: 302px;
          position: relative;
          div{
            line-height: 17px;
            width: 273px;
            position: absolute;
            top:50%;
            transform: translateY(-50%)
          }
        }
      }
      .points-th {
        height: 44px;
background: #F5F5F5;
 line-height: 44px;
font-size: 15px;
font-family: MicrosoftYaHei;
color: #262626;

      }
    }
  }

  .moneybox {
   display: flex;
   justify-content: space-between;
    float: left;
    border-radius: 10px;

    background-repeat: no-repeat;
    background-size: 100% 100%;
    align-items: center;
    div{
      img{
        width: 90px;
        height: 90px;
        margin-right: 20px;
      }
    }

    p {
      height: 19px;
font-size: 14px;
font-family: MicrosoftYaHei;
color: #535353;
line-height: 19px;
    }

    .text {

      height: 19px;
font-size: 14px;
font-family: MicrosoftYaHei;
color: #535353;
line-height: 19px;
    }

    .gota {
      margin-bottom: 5px;
    height: 26px;
font-size: 20px;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 26px;
    }

    &:nth-child(1) {
      margin-left: 0px;
      // background-image: url('/static/img/point_card_bg_1.png');


    }

    &:nth-child(2) {
      // background-image: url('/static/img/point_card_bg_2.png');
    }

    &:nth-child(3) {
      // background-image: url('/static/img/point_card_bg_3.png');
    }
  }

  .bill {
    padding-top: 20px;

    span {
      display: inline;
      padding-right: 30px;
      font-size: 18px;
      font-weight: 500;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/user/cont/mypoints.vue